module.exports = __webpack_public_path__ + "static/week_week5_spot1-c02aa2926c06a3e033d828085faefe0e.jpg";